<template>
  <div>
    <loading></loading>
  </div>
</template>

<script>
import Loading from "@/components/loading.vue";
export default {
  components: {
    Loading: Loading,
  },
  data: () => ({
    orderId: "",
    isFinishPage: false,
    isMobileCustomPayment: false,
    merchantUid: "",
  }),

  mounted() {
    var oParams = this.getUrlParams();
    console.log("oParams", oParams);

    // 모바일환경에서 신청내역 => 결제인 경우

    if (sessionStorage.getItem("isMobileCustomPayment")) {
      this.isMobileCustomPayment = true;
    } else {
      // 모바일환경 기본 결제인경우
      var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
      var finishPage = pOrder[pOrder.length - 1];

      if ("payment" === finishPage) {
        this.isFinishPage = true;
      }
    }

    this.orderId = oParams.merchant_uid;
    this.save(oParams.orderId, oParams.paymentKey, oParams.amount);
  },

  methods: {
    getUrlParams() {
      var params = {};
      window.location.search.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function (str, key, value) {
          params[key] = value;
        }
      );
      return params;
    },

    save(orderId, paymentKey, amount) {
      var sessionData = JSON.parse(localStorage.getItem("mobilePayData"));
      sessionData["orderId"] = orderId;
      sessionData["merchantUid"] = orderId;
      sessionData["amount"] = Number(amount);
      sessionData["paymentKey"] = paymentKey;

      let params = sessionData;

      this.axios
        .post(
          this.axios.root + this.axios.port + "/user/check-subjectdup",
          params
        )
        .then((res) => {
          if (res.data.err === 0) {
            this.axios
              .post(
                this.axios.root + this.axios.port + "/pay/confirmToApply",
                params
              )
              .then((res) => {
                if (res.data.err === 0) {
                  if (res.data.subjectList) {
                    sessionStorage.setItem(
                      "finishData",
                      JSON.stringify(res.data.subjectList)
                    );
                  }
                  localStorage.setItem("accessToken", res.data.accessToken);
                  this.axios.defaults.headers.common["accessToken"] =
                    res.data.accessToken;

                  // 모바일 환경 신청내역에서 다이렉트로 결제하는 경우 해당 sessionStorage 삭제
                  if (this.isMobileCustomPayment) {
                    sessionStorage.removeItem("isMobileCustomPayment");
                    alert("수강신청이 완료되었습니다.");
                    this.$router.push("/user/applyList");
                  } else if (this.isFinishPage) {
                    alert("수강신청이 완료되었습니다.");
                    this.$router.push("/user/applyList");
                  } else {
                    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
                    var idx = pOrder.indexOf("payment") + 1;
                    sessionStorage.setItem("step", pOrder[idx]);
                    this.$router.push(`/user/reg/${pOrder[idx]}`);
                  }
                } else {
                  alert(res.data.result);
                  this.$router.push("/user/reg/payment");
                  this.cancelPay();
                  return false;
                }
              });
          } else {
            alert(res.data.result);
            window.open(window.location.origin + "/user/reg/payment", "_blank");
            this.$router.push("/user/reg/payment");
            return false;
          }
        });
    },

    async cancelPay() {
      const oParams = this.getUrlParams();
      //가격 , 주문id
      await this.axios
        .post(
          this.axios.root +
            this.axios.port +
            "/pay/cancel?" +
            `amount=${oParams.amount}&orderId=${oParams.orderId}`,
          {}
        )
        .then((res) => {
          if (res.data.err == 0) {
            alert("결제 취소에 실패하였습니다.");
          }
        })
        .catch((err) => {
          console.error(`cancelPay error : `, err);
          alert("서버에러로 인하여 결제가 실패하였습니다.");
        });
    },
  },
};
</script>
